// Desktop-class device: fine pointer + hover. Touch devices (phones, tablets,
// the Flutter webview) report coarse/no-hover, so this cleanly excludes them.
export function isDesktop() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}
// Channels only exist inside the native app wrapper, so on web these calls no-op
// silently. Log every one — including the misses — so the handover is visible in
// the console. `logMessage` lets a caller redact a payload it shouldn't print.
function post(channel, message, logMessage = message) {
    const target = window[channel];
    const available = target ? '' : ' — channel NOT available (web browser?)';
    console.log(`[channel] ${channel}.postMessage('${logMessage}')${available}`);
    target?.postMessage(message);
}
// Bridge to the Flutter webview host. The Vibration channel is only present
// inside the native app wrapper; on web this call no-ops.
export function vibrate(type = 'default') {
    post('Vibration', type === 'default' ? 'vibrate' : type);
}
// Ask the host to prompt for push notification permission. Takes no payload.
export function enableNotifications() {
    post('enableNotifications', '');
}
// Hand the host credentials to store for biometric/auto login.
// Wire format is pin__email__password (double-underscore separated).
export function setCreds(pin, email, password) {
    // Never print the credentials themselves; just confirm the shape that went over
    post('setCreds', [pin, email, password].join('__'), '<pin>__<email>__<password> redacted');
}
// The host passes the device's safe-area insets on the launch URL. App.vue calls this, so
// it happens wherever the app lands rather than only on authenticated, menu-bearing routes.
export function captureSafeAreas(query, cookies) {
    if (query.st)
        cookies?.set('st', query.st, '1m');
    if (query.sb) {
        let sb = parseInt(query.sb);
        // Halving under 35 is kept verbatim from MenuBar, which used to own this
        if (sb < 35)
            sb = Math.floor(sb / 2);
        cookies?.set('sb', String(sb));
    }
}
